import { FC } from 'react';
import { ControlButton, DocumentViewerControlsContainer } from '../styles';

interface DocumentViewerControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onDownload?: () => void;
  isZoomInDisabled?: boolean;
  isZoomOutDisabled?: boolean;
}

const DocumentViewerControls: FC<DocumentViewerControlsProps> = ({
  onZoomIn,
  onZoomOut,
  onDownload,
  isZoomInDisabled = false,
  isZoomOutDisabled = false
}) => {
  return (
    <DocumentViewerControlsContainer>
      {onDownload && (
        <ControlButton
          onClick={onDownload}
          title="Download Document"
          aria-label="Download Document"
        >
          <img src="/assets/images/download.svg" alt="Download" />
        </ControlButton>
      )}
      <ControlButton
        onClick={onZoomOut}
        disabled={isZoomOutDisabled}
        title="Zoom Out"
        aria-label="Zoom Out"
      >
        <img src="/assets/images/zoom-out.svg" alt="Zoom Out" />
      </ControlButton>
      <ControlButton
        onClick={onZoomIn}
        disabled={isZoomInDisabled}
        title="Zoom In"
        aria-label="Zoom In"
      >
        <img src="/assets/images/zoom-in.svg" alt="Zoom In" />
      </ControlButton>
    </DocumentViewerControlsContainer>
  );
};

export default DocumentViewerControls;
